module.exports = __webpack_public_path__ + "static/img/ps_down_text.115a76e2.png";